import Link from '@mui/material/Link'

export const urlFromLocationName = (locations, inputString) => {
  if (!inputString) {
    return <span>{inputString}</span>
  }

  // Create a map of lowercase location names to their original names and URLs
  const locationMap = new Map()
  locations.forEach(loc => {
    if (loc.name && loc.googleUrl) {
      locationMap.set(loc.name.toLowerCase(), {
        originalName: loc.name,
        googleUrl: loc.googleUrl
      })
    }
  })

  if (locationMap.size === 0) {
    return <span>{inputString}</span>
  }

  const stringLower = inputString.toLowerCase()
  const result = []
  let currentPos = 0

  // Find all location names in the string
  while (currentPos < inputString.length) {
    let foundLocation = null
    let foundIndex = -1

    // Check for any location name starting at current position
    locationMap.forEach((locationData, lowerName) => {
      const index = stringLower.indexOf(lowerName, currentPos)
      if (index !== -1 && (foundIndex === -1 || index < foundIndex)) {
        foundLocation = locationData
        foundIndex = index
      }
    })

    if (foundIndex === -1) {
      // No more locations found, add remaining text
      result.push(inputString.substring(currentPos))
      break
    }

    // Add text before the location name
    if (foundIndex > currentPos) {
      result.push(inputString.substring(currentPos, foundIndex))
    }

    // Add the location name as a link
    result.push(
      <Link
        key={`${foundIndex}-${foundLocation.originalName}`}
        href={foundLocation.googleUrl}
        target='_blank'
        rel='noopener'
        sx={{ textDecoration: 'underline' }}
      >
        {inputString.substring(foundIndex, foundIndex + foundLocation.originalName.length)}
      </Link>
    )

    // Move current position past this location name
    currentPos = foundIndex + foundLocation.originalName.length
  }

  return <span>{result}</span>
}
